import {
    observable,
    action,
    computed,
    //runInAction
} from 'mobx'
import { toJS } from 'mobx';
//import {loadUrlConfig} from '../api/login.api'
import qs from 'qs'
import {
    getQueryVariable,
    prop,
    storageGetItem,
    storageSetItem,
    windowActionFn,
    encryptAES,
    isPdfOnlineDomain,
    isCommonFeatureDomain,
    isCNDomain,
    isJPDomain,
    getOnlineUrl,
    isDevDomain, isAzk8sDomain, isDemo4Domain, isCADomain, isEUDomain, isFromOfficeAddIn, getFoxitStoreDomain,
    getLocalStorageUserMapValue, setLocalStorageUserMapValue,
} from 'Utils/utils';
import { baseUrlApis, loginApis, cookies, platformApis, /*otelApi,*/ collaborationApi} from 'Api/index';
import {userService, browserService, userBehaviorTrackingService, thirdPartyService} from './services/index'
import {store} from './store.index';
import { GOT_USER_SUBSCRIPTION, USER_IS_ADMIN } from './constants';
import * as APP_CONSTANTS from 'Constants/app.constant';
// import { hasUsData } from "../components/dialogs/MessageCenter/Type";

import {
    SIGN_UP_SUCCESS_FROM_XXX,
    SIGN_UP_SUCCESS_FROM_FOXIT,
    DOCUMENT_DURATION,
    //SIGN_IN_SUCCESS,
    //SIGN_IN_FAILED
} from 'Components/viewer/ui/constants/event.constants';
import {
    USER_TYPE_EDU,
    USER_TYPE_NON_EDU,
    EXIT,
    TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_SIGNIN_SUCCESSFUL,
    TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_SIGNIN_INTERRUPTED,
    TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_LABEL
} from 'Components/viewer/ui/constants/user.more.constants';

import {
    isMobile,
} from 'Components/viewer/ui/constants/index';
import {  fileController } from "Components/viewer/Controllers/index";
import { isSharedClound } from '@/api/index';
import { signOutIfTeamsWebsiteUrl, useWindow } from '@/api/ms_api_for_teams_app.api';
import { isTeamsApp } from '@/utils/device';
import { simplyGetRootDomain } from '@/utils/url';
import { getFoxitTokenWithinTeams } from '@/modules/msTeams/services/token';
import { signOutFoxitWithinTeams } from '@/modules/msTeams/services/signOut';
import { queryFromTeams } from '@/modules/queryData';
import { sharePointGASender } from './services/GoogleAnalyticsSender';
import _isNil from 'lodash/isNil';
import { isDTRuntime } from '@/modules/3rd-party-integration/utils/env';
import { DingtalkModule } from '@/modules/dingtalk/lazy-load';

const encryptKey = 'p1iZkba85IwaQ65t';

class UserStore {
    @observable updateRoleInfoSuccessFlag = false
    @observable casService = null
    @observable foxitSignEnvelopeInfo = null;
    @observable allowNoSignIn = false
    @observable isLoadingUserAccount = true;
    @observable requestEnterpriseTask = null;
    @action initialize() {
        baseUrlApis.initialize();
        platformApis.initialize();
    }
    @observable jwt = null;
    // @observable token = '123123';
    @observable token = '';
    @observable isTokenExpired = false;
    @observable eSign_token = '';
    @observable tokenCache = null;
    // role: type =0 表示企业普通用户，type =1 表示企业管理员
    @observable roleInfo = {
        type: 1,
    };
    /** be used in mobile */
    @observable isPopSignInWindow = false;
    @observable isShowSubscribe = false;
    @observable isShowAccount = false;
    @observable isShowActivate = false;
    @observable isEdu = false;
    @observable isOriginalSubscribe = false;
    @observable hasCheckEdu = false;
    @observable invisibleOpenSaveBtn = [];
    @observable isNeedSignIn = false;
    @observable isShowSignUpDlg = false;
    @observable isShowWelcomeDlg = false;
    @observable isShowRedeemDlg = false;

     // add by luchao


    /**
     * {
        avatar: "https://pheecws-fzk8s.connectedpdf.com/img/gravatar_default.png"
        cUserID: "53f2cf9a0cf261f21c11aaa2"
        firstname: "11"
        full_name: "11 222222222222222"
        fullname: "11 222222222222222"
        lastlogintime: "Last login 1 min ago"
        lastname: "222222222222222"
        register_type: 1
        userEmail: "admin@fp.com"
        userMobile: null
     * }
     */
    @observable.ref userInfo = {
        avatar: "https://pheecws-fzk8s.connectedpdf.com/img/gravatar_default.png",
        cUserID: "53f2cf9a0cf261f21c11aaa2",
        firstname: "11",
        full_name: "11 222222222222222",
        fullname: "11 222222222222222",
        lastlogintime: "Last login 1 min ago",
        lastname: "222222222222222",
        register_type: 1,
        userEmail: "admin@fp.com",
        userMobile: null,
    };
    @observable tokenTimer = null;
    @observable hasHistoricalData = false;
    @observable signUpPopupSrcType = null;
    @observable popupSignUpOrSignIn = false;
    @action showPopupSignUpOrSignIn() {
        this.popupSignUpOrSignIn = true
    }
    @action hidePopupSignUpOrSignIn() {
        this.popupSignUpOrSignIn = false
    }
    @action updateCasService(url) {
        this.casService = url
    }
    @action updateSignUpPopupSrcType(value) {
        this.signUpPopupSrcType = value
    }
    @action resetSignUpPopupSrcType() {
        this.signUpPopupSrcType = null
    }
    @action loopToGetSubscribeState() {
        store.appStore.showLoading(true);

        return new Promise((resolve, reject) => {
            let counter = 0
            const flag = setInterval(() => {
                const { roleInfo, updateRoleInfoSuccessFlag } = this;
                const { subscriptionState } = store.accountStore;

                // 防止加载动画被其他逻辑关闭
                store.appStore.showLoading(true);

                if ((roleInfo && updateRoleInfoSuccessFlag) || subscriptionState) {
                    store.appStore.showLoading(false)
                    clearInterval(flag)
                    resolve()

                    return
                }
                if (counter >= 60) {
                    store.appStore.showLoading(false)
                    clearInterval(flag)
                    reject(0)

                    return
                }

                counter++;
            }, 1000);
        })
    }
    @action hasSubscribePermissionSync() {
        const { isOnPremiseDeployMode } = store.appStore;
        const { isEnterpriseUser, hasEditPermissionAndEnterpriseUser } = this;
        const { isActive, isTrial } = store.accountStore;

        if (!isEnterpriseUser && !isOnPremiseDeployMode && (isActive || isTrial)) {
            return true
        }
        if (isEnterpriseUser && hasEditPermissionAndEnterpriseUser) {
            return true
        }

        return false
    }
    @action async hasSubscribePermission() {
        const { isOnPremiseDeployMode } = store.appStore;
        const { roleInfo, updateRoleInfoSuccessFlag } = this;
        const { subscriptionState } = store.accountStore;

        try {
            if ((!roleInfo && !subscriptionState) || (roleInfo && !updateRoleInfoSuccessFlag)) {
                await this.loopToGetSubscribeState()
            }
        } catch (error) {
            return error
        }

        const { isEnterpriseUser, hasEditPermissionAndEnterpriseUser } = this;
        const { isActive, isTrial } = store.accountStore;

        if (!isEnterpriseUser && !isOnPremiseDeployMode && (isActive || isTrial)) {
            return true
        }
        if (isEnterpriseUser && hasEditPermissionAndEnterpriseUser) {
            return true
        }

        return false
    }
    @action setAllowNoSignIn(value) {
        this.allowNoSignIn = value
    }
    @action updateFoxitSignEnvelopeInfo(value) {
        this.foxitSignEnvelopeInfo = value
    }
    @action updateJWT(value) {
        this.jwt = value
    }
    @action updateESignToken(value) {
        this.eSign_token = value
    }
    @action doShowWelcomeDlg() {
        this.isShowWelcomeDlg = true
    }
    @action doHideWelcomeDlg() {
        this.isShowWelcomeDlg = false
    }
    @action setSubscribeVisible(visible){
      if(visible && !window.__online__){
        store.appStore.doNotifyErrors('offline');
        return;
      }
      if (visible && isDTRuntime) {
        DingtalkModule.trialEndAndPurchaseNowWithinDingtalk();
        return;
      }
      //ONLINERD-2646 美国区直接跳转到官网
      //ONLINERD-3023 中国区教育用户直接跳转到Appstore
      if (visible && (isPdfOnlineDomain() || isCommonFeatureDomain() || (isCNDomain() && this.isEdu))) {
        let target = 'app-list';
        store.accountStore.doGoToAppShopping({ target, original: this.isOriginalSubscribe });
        return;
      }
      this.isShowSubscribe = visible;
    }
    @action setAcountVisibe(visible){
        this.isShowAccount = visible;
    }
    @action setActivateVisibe(visible){
        this.isShowActivate = visible;
    }
    @action setTokenCache(value){
      this.tokenCache = value;
    }

    @action doGetTicket(url, callback){
        //{email, url, token}
        if(!this.userInfo){
            callback && callback('');
            return;
        }
        const {userEmail, userMobile} = this.userInfo;
        let params = {
            userMobile,
            email:userEmail,
            token:this.token,
            url
        }
        userService.getTicket(params, callback)
    }

    @action getUnsubTicket(){
        let domain = '';
        if(isDevDomain()||isAzk8sDomain()||isDemo4Domain()){
            domain = 'https://www-test.foxitsoftware.com';
        }else{
            domain = 'https://www.foxit.com';
        }
        // domain may not correct
        const href = window.location.href;
        if(href.includes('localhost')||href.includes('azk8s')||href.includes('demo4')){
            domain = 'https://www-test.foxitsoftware.com';
        }

        const updateStripes = JSON.parse(window.localStorage.getItem('stripe_s_i')||'{}');
        const {userSubStripeId} = store.accountStore;
        const email = this.userAcount;
        const sid = updateStripes[email]?updateStripes[email]:userSubStripeId;

        let winEnv =  windowActionFn(window, 'open', ['about:blank']);
        const ticketUrl = 'https://www.foxitsoftware.com';
        store.userStore.doGetTicket(ticketUrl,ticket=>{
            if(winEnv.closed) {
                return
            }

            let targetUrl = `${domain}/account/subscription.html?sid=${sid}&ticket=${ticket}`;
            winEnv.document.location.href = targetUrl;

            let _hTime = setInterval(()=>{
                if(winEnv.closed) {
                    store.accountStore.getSubscribeStateNow();
                    window.localStorage.setItem('has-canceled-sub','y');
                    clearInterval(_hTime);
                }
            },2000);
        })
    }

    @action goFoxitStore(){
        const domain = getFoxitStoreDomain();
        const ticketUrl = 'https://www.foxitsoftware.com';
        store.userStore.doGetTicket(ticketUrl,ticket=>{
            let targetUrl = `${domain}/shopping/?ticket=${ticket}`;
            let winEnv = window.open(targetUrl,'_blank');
            if(winEnv.closed) {
                return
            }

            let _hTime = setInterval(()=>{
                if(winEnv.closed) {
                    this.getUserSubInfoRightNow();
                    clearInterval(_hTime);
                }
            },2000);
        })
    }

    @action goToFoxitOnlineAbout() {
        const domain = getFoxitStoreDomain();
        const ticketUrl = 'https://www.foxitsoftware.com';
        store.userStore.doGetTicket(ticketUrl, ticket => {
            const targetUrl = `${domain}/pdf-editor/cloud/?ticket=${ticket}`;
            window.open(targetUrl, '_blank');
        });
    }

    // accountStore.doGoToAppShopping 也是添加到shopping car
    @action addToStoreShoppingCar({ license, sku }){
        const domain = getFoxitStoreDomain();
        const ticketUrl = 'https://www.foxitsoftware.com';
        store.userStore.doGetTicket(ticketUrl, ticket => {
            let lang = store.appStore.lng ? store.appStore.lng.full: 'en-US';
            let _default = {
                sku,
                license,
                lang,
                language:lang,
            }
            let targetUrl = `${domain}/shopping/subscription-checkout.html?${qs.stringify(_default)}&ticket=${ticket}`;
            let winEnv = window.open(targetUrl, '_blank');
            if (winEnv.closed) {
                return;
            }

            let _hTime = setInterval(() => {
                if (winEnv.closed) {
                    this.getUserSubInfoRightNow();
                    clearInterval(_hTime);
                }
            }, 2000);
        });
    }

    @action getUserSubInfoRightNow() {
        if (this.isEnterpriseUser) {
            const { type, enterpriseId } = this.roleInfo;
            this.updateRoleInfo(Number(type), enterpriseId, true);
        } else {
            store.accountStore.getSubscribeStateNow();
        }
    }

    @action doGoToOnlineFromTeam(){
        let lang = store.appStore.lng ? store.appStore.lng.full: 'en-US';
        let _default = {
            from:'teamsub',
            al: lang,
            an: 'Foxit PhantomPDF Online',
        }

        let ticketUrl = `${window.location.origin}/?${qs.stringify(_default)}`
        store.userStore.doGetTicket(ticketUrl, (ticket) => {
            let targetUrl = `${ticketUrl}&ticket=${ticket}`;
            if(!ticket){
                targetUrl = ticketUrl;
            }

            if(!window){
                return;
            }

            let winEnv = window.open(targetUrl,'_blank');
            if(winEnv.closed) {
                return
            }
            const _hTime = setInterval(()=>{
                if(winEnv.closed) {
                    clearInterval(_hTime)
                    callback && callback()
                    store.accountStore.doGetSubscribeInfo()
                }
            },2000);
        });
    }

    @action doGoToAccount( callback ){
        let winEnv =  windowActionFn(window, 'open', ['about:blank']);
        let lang = store.appStore.lng ? store.appStore.lng.full: 'en-US';
        let _default = {
            from:'online',
            al: lang,
            an: 'Foxit PhantomPDF Online',
        }

        const {isDashboardTrial} = store.accountStore;
        if (isDashboardTrial) _default.bFree = 1;

        let ticketUrl = `${store.appStore.accountUrl}/?${qs.stringify(_default)}`
        if (store.accountStore.distributorID) {
            ticketUrl = `${ticketUrl}&distributorID=${store.accountStore.distributorID}`
        }
        let server_config = getQueryVariable('server_config');
        if(!!server_config){
            ticketUrl += `&server_config=${server_config}`
        }

        store.userStore.doGetTicket(ticketUrl, (ticket) => {
            let targetUrl = `${ticketUrl}&ticket=${ticket}`;
            if(!ticket){
                targetUrl = ticketUrl;
            }

            if(winEnv.closed) {
                return
            }
            winEnv.document.location.href = targetUrl;

            let _hTime = setInterval(()=>{
                if(winEnv.closed) {

                    clearInterval(_hTime)
                    callback && callback()
                    store.accountStore.doGetSubscribeInfo()
                }
            },2000);
        });
    }
    @action doModifyPassword({old_password, new_password}, callback){
        userService.modifyPassword({old_password, new_password, token:this.token}, callback)
    }
    @action doUpdateUserInfo({first_name, last_name, bUsedPPO}, callback) {
        userService.updateUserInfo({ first_name, last_name, bUsedPPO }, callback)
    }

    @action async doUpdateUserInfoWithAutoRefreshStore({ phone }, callback) {
        return
        phone = phone && await encryptAES(phone, this.getEncryptKey(), '');
        await userService.updateUserInfo({ phone }, async () => {
            const { info } = await userService.getUserInfo(store.userStore.token);
            this.userInfo = info;
            callback()
        });
    }
    /**
     * if not login in, return 'anonymous', otherwise will return user email.
     *
     * @readonly
     * @returns {String}
     */
    @computed get userAcount(){
        if(!this.userInfo)return 'anonymous';

        const { userEmail, fullname, userMobile} = this.userInfo

        return userEmail || fullname ||  userMobile;
    }
    @computed get userId(){
        if(!this.userInfo)return '';
        return this.userInfo.cUserID
    }
    @computed get userName(){
        if(!this.userInfo)return '';
        const {fullname, userEmail, firstname, lastname, showName, userMobile} = this.userInfo;
        let name = '';
        if (showName) {
            name = showName;
        } else if (firstname && lastname) {
            name = firstname + ' ' + lastname;
        } else if (firstname) {
            name = firstname ;
        } else if (lastname) {
            name = lastname ;
        } else if (fullname) {
            name = fullname;
        } else if (userEmail) {
            name = userEmail.split('@')[0];
        } else {
            name = userMobile
        }
        if ((name && name.trim()) === '') {
            name = userEmail.split('@')[0];
        }
        return name;
    }
    @computed get avatar(){
        if(!this.userInfo)return '';
        return this.userInfo.avatar
    }
    @computed get isDefaultAvatar(){
        if(!this.userInfo)return '';
        return this.userInfo.isDefaultAvatar
    }
    @action updateUserName({firstname, lastname, fullName, showName}){
        if(!this.userInfo)return '';
        if (typeof(showName) != 'undefined') {
            this.userInfo.showName = showName;
        }
        if (typeof(firstname) != 'undefined') {
            this.userInfo.firstname = firstname;
        }
        if (typeof(lastname) != 'undefined') {
            this.userInfo.lastname = lastname;
        }
        if (typeof(full_name) != 'undefined') {
            this.userInfo.fullname = fullName;
        }
        this.userInfo = {...this.userInfo}
    }
    @action updateUserAvatar({avatar, isDefaultAvatar}){
        if(!this.userInfo)return '';
        this.userInfo.avatar = avatar;
        this.userInfo.isDefaultAvatar = isDefaultAvatar;
        this.userInfo = {...this.userInfo}
    }
    @observable trustConfig = {
        isEnableJS:true,
        isEnableSafeMode:true
    }
    @computed get isEnableJS(){
        return this.trustConfig.isEnableJS;
    }
    @computed get isEnableSafeMode(){
        return this.trustConfig.isEnableSafeMode;
    }
    doUpdateDocOpenTime(){
        let _docOpenTime = new Date().getTime();
        window.sessionStorage.setItem('__doc_open_time__', JSON.stringify({value: _docOpenTime}));
    }
    @action doSendGAEventByDocDuration(){
        let _docOpenTime = window.sessionStorage.getItem('__doc_open_time__');
        if(_docOpenTime){
            window.sessionStorage.removeItem('__doc_open_time__')
            _docOpenTime = JSON.parse(_docOpenTime).value;
            let _endTime = new Date().getTime();
            let duration = (_endTime - _docOpenTime)/1000>>>0;
            store.userStore.doSendGAEvent({eventKey: DOCUMENT_DURATION, label:'doc_event', value:duration})
        }
    }
    @action doSendGAEvent({eventKey, label, category, action, value}){
        userBehaviorTrackingService.doSendGAEvent({eventKey, label, category, action, value})
    }
    @action doSendNPSData({action, extraInformation}){
      let channel = !isJPDomain()? 'Foxit Editor Cloud':'Foxit Editor Cloud For JP';
      userBehaviorTrackingService.doSendNPSData({action, extraInformation, channel})
    }
    @action doSendGAEventByUser({eventKey, label, param,extraInformation}){
        userBehaviorTrackingService.doSendGAEventByUser({eventKey, label, param,extraInformation})
    }
    @action doSendGAEventByUserEvent(eventKey, addedValue, callback) {
        userBehaviorTrackingService.doSendGAEventByUserEvent(eventKey, addedValue, callback);
    }
    @action setInvisibleOpenSaveBtn(invisibleOpenSaveBtn) {
        this.invisibleOpenSaveBtn = invisibleOpenSaveBtn;
    }
    @action getDrivesConfig({ enterprise_id, success, fail }) {
        baseUrlApis.getDrivesConfig({ enterprise_id, success, fail }).then((result)=>{
            //const { data } = result;
            success && success(result)
        }).catch((reason => {
            fail && fail(reason)
        }));
    }
    @action updateUserInfoToServer({ params, success, fail }) {
        const { bUsedPPO } = params;
        userService.updateUserInfo({ bUsedPPO }, (result)=>{
            if(result && result.ret === 0){
                success && success(result)
                return
            }
            fail && fail(result)
        })
        //userService.updateUserInfo({ params, success, fail });
    }
    @action getTrustConfig(){
        const account = this.userAcount;
        let value = storageGetItem(localStorage, account +"_trust");
        if(!value){
            return this.trustConfig;
        }
        let cfg = JSON.parse(value)
        this.trustConfig = cfg;
        return cfg
    }
    @action setTrustConfig({isEnableJS, isEnableSafeMode}){
        this.trustConfig = {
            isEnableJS,
            isEnableSafeMode
        }
        const account = this.userAcount;
        storageSetItem(localStorage, account +"_trust", JSON.stringify({isEnableJS, isEnableSafeMode}));
    }

    userTip = {};
    @action setShowDlgControl(dialogKey, isShow){
        let val = storageGetItem(localStorage, 'user-tip');
        let value = {};
        let users = {};
        if(val){
            users = JSON.parse(val);
            value = (users[this.userAcount])?users[this.userAcount]:{}
        }
        // {'ssss@sss.com':{watermark:'show'}}
        value[dialogKey] = isShow?'show':'hide';
        users[this.userAcount] = value;
        this.userTip = value;

        //value[this.userAcount] = value?'show':'hide';
        storageSetItem(localStorage, 'user-tip', JSON.stringify(users));
    }
    @action checkShowDlgControl(dialogKey, callback){
        // default return true
        // no data in storage
        let val = storageGetItem(localStorage, 'user-tip');
        if(!val){
            callback && callback(true);
            return true;
        }
        // no data for this user
        let value = JSON.parse(val);
        let info = value[this.userAcount];
        if(!info){
            callback && callback(true);
            return true;
        }
        // show or hide
        this.userTip = info;
        let isShow = info[dialogKey] === 'show' ?true:false;
        callback && callback(isShow);
        return isShow;
    }

    @action setEdu(value){
        this.isEdu = value;
        this.hasCheckEdu = true;

        //GA: user_type_edu or user_type_non_edu
        userBehaviorTrackingService.doSendGAEventByUserEvent(value?USER_TYPE_EDU:USER_TYPE_NON_EDU, null);
    }
    @action setOriginalSubscribe(value) {
        this.isOriginalSubscribe = value;
    }
    /* @action doCheckUserDetail(){
        if(this.hasCheckEdu || !this.token)return;
        userService.onCheckUserEmailType();
    } */
    @action clean(isCleanCache, notCleanStoreData){
        if (!notCleanStoreData) {
            this.token = "";
            this.tokenCache = null;
            this.userInfo = null;
            // this.roleInfo = null;
        }

        window.sessionStorage.removeItem('driver_access_token');
        window.sessionStorage.removeItem('userInfo');
        if(isCleanCache){
          this.cleanTokenCache()
        }
    }
    @action cleanLogin(isCleanCache){
        this.clean(isCleanCache);
        loginApis.cleanStorage(isCleanCache);
    }
    /* @computed tokenInPlatform(){
        return '';
    } */
    @computed get hasSignIn(){
        return store.loginNewStore.isLogin
        let val = (this.token && this.userInfo)?true:false;
        return val;
    }

    @action doMockUser(){
        userService.doMockUser((user)=>{
            this.token = '5ec22290c3dd8f000144099e'
            this.userInfo = user;
        })
    }

    async getToken(){
        if(this.token){
            return this.token;
        }

        // ===> test performance start
        const vTest = baseUrlApis.getQueryVariable("test");

        if (vTest === 'performance') {
            const email = getQueryVariable("username");
            const password = getQueryVariable("password")
            const userMobile = getQueryVariable("userMobile");

            if ((email || userMobile) && password) {
                try {
                    const res = await userService.doLoginByApi({ email, userMobile, password })

                    if (res.ret === 0) {
                        return res.data.access_token
                    }
                } catch (error) {
                    store.appStore.setGlobalMessage({type: "error", content: "login failed"})
                }
            }
        }
        // ===> test performance end

        // teams getToken
        const utoken = baseUrlApis.getQueryVariable("token");
        if (store.teamsAppStore.inTeamsApp && utoken) {
            // 去除地址栏token参数
            const search = location.search.replace(/[&?]?token=[^&\W]*/,'');
            window.history.replaceState({}, 0, search);
            return utoken;
        }

        let token = window.sessionStorage.getItem('driver_access_token');
        if (!token) token = cookies.get('currentToken');
        if (!token) return '';
        this.token = token;
        return token;
    }
    @action updateUserInfoWithinDingtalk(info) {
        this.userInfo = info;
    }
    @action async updateUserInfo(info){
        // TODO ga => new user ,sign up; sign in
        return new Promise((resolve) => {
            this.userInfo = info;
            if (!info) {
                return resolve(null);
            }
            //

            //
            let isSend = false;
            if (!info.bUsedPPO || info.bUsedPPO !== 1) {
                isSend = true;
                this.updateUserInfoToServer({
                    params: { bUsedPPO: '1' }, success: () => {
                        return resolve(info);
                    }, fail: () => {
                        return resolve(info);
                    },
                });
            }

            const MESSAGE_KEY = 'online.user.status';
            // listen 'sign out' from parent window
            loginApis.doListenSubWindowAction(MESSAGE_KEY, () => {
                this.clean(true);
            }, true);

            userBehaviorTrackingService.doSetUserId(info.cUserID);
            if (info.newUserFrom && info.newUserFrom !== 'foxit') {
                userBehaviorTrackingService.doSendGAEventByUserEvent(SIGN_UP_SUCCESS_FROM_XXX, info.newUserFrom);
            }
            if(isSend)return;
            store.appStore.emitEvent('has-sign-in-success');
            return resolve(info);
        });
    }

    @computed get isEnterpriseUser(){
        return false;
    }
    // now, only check permission of enterprise user
    @computed get hasEditPermissionAndEnterpriseUser(){
        if(!this.roleInfo)return false;
        return (this.roleInfo.state === 0);
    }
    @action loadEnterpriseUserPermission(enterpriseId, isForceUpdate = false){
      if(isForceUpdate || !this.requestEnterpriseTask){
        this.requestEnterpriseTask = userService.getEnterpriseUserPermission(enterpriseId);
      }
      return this.requestEnterpriseTask;
    }
    @action updateRoleInfo(type, enterpriseId, isForceUpdate = false){
        // getEnterpriseUserPermission
        let state = -1;
        this.roleInfo = {
            type,
            enterpriseId,
            state
        }
        const fn = ()=>{
            const token = toJS(this.token)

            if (!token) {
                return
            }

            let value = {};
            let date = new Date();
            const domain = simplyGetRootDomain()

            date.setTime(Date.now() + (7*24*60*60*1000));
            value[token] = this.roleInfo;

            const roleString = JSON.stringify(value)

            storageSetItem(localStorage, 'role', roleString);
            cookies.set('role', roleString, { path: '/', expires: date, secure: true, sameSite: 'none', domain });
        }

        fn();

        // 1为超管 2为普通管理员
        if([1,2].includes(Number(type))){
            store.appStore.doNoticeMessage(USER_IS_ADMIN);
        }

        return this.loadEnterpriseUserPermission(enterpriseId, isForceUpdate).then((result)=>{
           if(result){
               state = result.ret;

               if (isPdfOnlineDomain() || isCommonFeatureDomain()) {
                   // sub_type: 0赠送,  1或者'' 购买, 2试用
                   const { remain_days: rd, sub_type } = result.data;
                   store.accountStore.setSubscribeInfo({ remain_days: rd });
                   store.accountStore.setTrialFrom('bundle_trial');

                   let status = 'trailExpired';
                   if (result.ret === 0) {
                       status = 'active';
                       if (sub_type === '2' && !_isNil(rd) && rd >= 0) {
                           status = 'trail';
                       }
                   } else {
                       // if (_isNil(rd) && !_isNil(sub_type) && sub_type !== '2') {
                       //     status = 'noFirstTrailed';
                       // }
                       // if (!_isNil(rd) && rd <= 0 && !_isNil(sub_type) && sub_type === '2') {
                       //     status = 'trailExpired';
                       // }
                       if (result.ret === 50002) { // 过期 弹bundle
                           status = 'expired';
                       }
                       if (result.ret === 50004) {
                           if ('sub_type' in result.data && sub_type !== '2' && !_isNil(rd)) { // 有订阅 过期 弹bundle
                               status = 'expired';
                           } else if ('sub_type' in result.data && sub_type === '2') { // 试用 过期
                               status = 'expired';
                           } else {// 未订阅 14天trial
                               status = 'noFirstTrailed';
                           }
                       }
                   }
                   store.accountStore.setSubscriptionState(status);
                   if (['active'].includes(status)) {
                       store.appStore.emitEvent('has-close-shopping-car', false);
                   }
               }
          }
          this.roleInfo.state = state;
          this.updateRoleInfoSuccessFlag = true
          store.appStore.emitEvent(GOT_USER_SUBSCRIPTION)
          fn();
        })

    }
    // 1为超管 2为普通管理员     超管也是管理员
    @computed get isAdmin(){
        if(this.roleInfo && [1,2].includes(Number(this.roleInfo.type))){
            return true;
        }
        return false;
    }
    @computed get isSuperAdmin(){
        if(this.roleInfo && Number(this.roleInfo.type) === 1){
            return true;
        }
        return false;
    }
    @action async updateToken(token){
        this.token = token;
        if(store.teamsAppStore.inTeamsApp){
          return;
        }

        collaborationApi.setToken(token)
        window.sessionStorage.setItem('driver_access_token',token);
        window.sessionStorage.setItem('driver_access_token_for_auto_login', token)
        window.localStorage.setItem('driver_access_token_for_auto_login', token)

        let date = new Date();
        const domain = simplyGetRootDomain()

        date.setTime(Date.now() + (7*24*60*60*1000));
        cookies.set('currentToken', token, { path: '/', expires: date, secure: true, sameSite: 'none', domain });
    }
    @action updateIsTokenExpired(isTokenExpired) {
        this.isTokenExpired = isTokenExpired;
    }

    @action cleanTokenCache(){
      const { inTeamsApp } =store.teamsAppStore

      if (inTeamsApp) {
        cookies.set('currentToken', '', { path: '/' });
        cookies.remove('currentToken', { path: '/' });
        cookies.set('role', '', { path: '/' });
        cookies.remove('role', { path: '/' });
      } else {
        const domain = simplyGetRootDomain()

        cookies.set('currentToken', '', { path: '/', domain });
        cookies.remove('currentToken', { path: '/', domain });
        cookies.set('role', '', { path: '/', domain });
        cookies.remove('role', { path: '/', domain });
      }
      window.sessionStorage.removeItem('driver_access_token')
    }

    @action getUserJWT(from){
        return userService.getUserJWT(this.token, from);
    }
    @action reLoadUserApisForServiceWorker(){
      try {
        return userService.reLoadUserApisForServiceWorker();
      } catch (error) {
        store.appStore.outputErrorLog(error)
      }
    }
    @action initProcessClosSignUpPopup() {
        this.popupSignUpOrSignIn = false;
    }
    @action initProcessNeedLogin(pathname, isAutoLoginFlow) {
        if (isAutoLoginFlow) {
            this.popupSignUpOrSignIn = true

            return
        }

        const isThirdPartyLoginFlow = thirdPartyService.isLoginFlow()

        // 第三方登录流程 和 PWA 不用显示登录弹窗
        if (isThirdPartyLoginFlow || pathname === '/open-pdf') {
            this.popupSignUpOrSignIn = false

            return
        }

        // Currently, Only '/' need pop up signup, otherwise not change(like '/feedback')
        if (!isMobile() && pathname === '/') {
            if (thirdPartyService.isFromThirdParty() !== 'Sharepoint') {
                this.popupSignUpOrSignIn = true;
            }
        } else {
            this.loginIn(true);
        }
    }
    @action async initializeOnFirst(pathname) {
        let result;
        let isToSignIn = false;
        try {
            do {
                // ticket
                result = await userService.getUserInfoByTicket();
                if( result.ret !== 0 || result.token ){
                    if(result.token) {
                        //ONLINERD-6688 登录成功->
                        this.checkUserEnv(result.token);
                        store.foxitSignStore.initFoxitSignCountInfo();
                        store.appStore.initEnterpriseSettingInfo();
                    }
                    break;
                }

                const isThirdPartyLoginFlow = thirdPartyService.isLoginFlow()

                if (isThirdPartyLoginFlow) {
                    const { ret, token} = await thirdPartyService.getAccessToken()

                    if (ret === 0 && token !== null) {
                        try {
                            const res = await userService.checkTokenAndInitUserInfo(token, null, null, true)

                            if (res && res.ret === 0) {
                                this.checkUserEnv(token)
                                store.historyStore.push({pathname:'/', search:''});
                            }
                        } catch (error) {
                            console.error(error);
                        }
                    } else {
                        store.appStore.setGlobalMessage({type: 'error', content: 'InvalidToken'})
                    }
                    break;
                }

                // phantom/ mac platform

                // error page

                // check userInfo when switch page, such as '/ => /user/info'
                if(this.userInfo){
                    // update some data;
                    break;
                }

                // sign-up
                // check token when refresh page
                let enterpriseId, role, token;
                if (queryFromTeams) {
                    ({ token, enterpriseId, role } = await getFoxitTokenWithinTeams());
                } else {
                    token = await this.getToken();
                }

                let isFromAppstore_myorders = getQueryVariable('from') === 'appstore_myorders';
                let isFromServiceModeOfClient = store.appStore.isFromServiceModeOfClient;

                this.clean();
                // check token cache
                if (!token) {
                  // check 'remember-me'
                  if(userService.doCheckLogInAgain(pathname)){
                    isToSignIn = true;
                    if (isFromAppstore_myorders || isFromOfficeAddIn()) {
                        this.loginIn(true);
                    } else {
                        if (!isFromServiceModeOfClient) {
                            this.initProcessNeedLogin(pathname);
                        }
                    }
                  }
                  break;
                }
                // check password expired
                result = await userService.checkTokenAndInitUserInfo(token, enterpriseId, role);

                // token is valid(ret === 0)

                if(result.ret === 0){
                    //ONLINERD-6688 已登录状态重新加载online->
                    this.checkUserEnv(token);
                    store.foxitSignStore.initFoxitSignCountInfo();
                    store.appStore.initEnterpriseSettingInfo();
                    //this.doCheckUserDetail();
                    break;
                }
                // 210007, does to show dialog for goto cas?
                if(result.ret === 210007 ){
                    this.isTokenExpired = true;
                    if (this.hasSignIn && this.userInfo && this.userInfo.cUserID){
                        this.loginOut(true, userService.doCheckLogInAgain(), true);
                    }
                    break;
                }
                // if cache token is invalid, check 'remember-me'
                if(userService.doCheckLogInAgain(pathname)){
                    isToSignIn = true;
                    if (isFromAppstore_myorders) {
                        this.loginIn(true);
                    } else {
                        if (!isFromServiceModeOfClient) {
                            this.initProcessNeedLogin(pathname);
                        }
                    }
                }
            } while (false);
        } catch (error) {
            console.error("TCL: UserStore -> @actioninitializeOnFirst -> error", error)
        }

        this.onFinishInitialize(isToSignIn, pathname);
    }
    onFinishInitialize(isToSignIn, pathname){
      this.isLoadingUserAccount = false;
      if(isToSignIn){
        return;
      }
      store.appStore.emitEvent(APP_CONSTANTS.EVENT_USER_INITIALIZE_END);
      //
      this.doSendGAEventByDocDuration();
    //   this.showAiLitterHelper(pathname);
      let isRedeeemPathname = (pathname === '/redeem');
      if(isRedeeemPathname){
          this.isShowRedeemDlg = true
      }
      if(!browserService.isValidRoutePath(pathname)){
          console.warn("TCL: UserStore -> @action initializeOnFirst -> pathname", pathname, ", is not valid, will go to home page")
          browserService.doGoToHomePage()
      }
      //
      this.checkMockForTestPerformance();
    }
    checkAutoShowSignUp(){
      if(!isCNDomain() /* || store.teamsAppStore.inTeamsApp */ || this.hasSignIn){
        return;
      }
      const from = getQueryVariable('source');
      const state = getQueryVariable('state');
      const docidForOffice = getQueryVariable('docidForOffice');
      const ServerType = getQueryVariable('ServerType');
      const reviewSessionID = getQueryVariable('reviewSessionID')
      const fileLink = getQueryVariable('docUrl')
      if(from === 'online' && from === 'phantompdf'){
        return;
      }

      if ( !state && !ServerType  && !docidForOffice && !reviewSessionID && !fileLink) {
        setTimeout(() => {
          this.signUp(true);
        }, 0);
      }

    }
    checkMockForTestPerformance(){
      const vTest = baseUrlApis.getQueryVariable("mock");
      if (vTest === 'user') {
          this.doMockUser()
      }
    }
    isInSameEnv() {
      const { region } = this.userInfo
      const { environmentName } = store.appStore

      if (region === environmentName) {
        return true
      }
    }
    getServiceModeOfClientRedirectUrl(domain, userEnv) {
        let _domain = domain || getOnlineUrl(userEnv);
        const { serviceModeOfClientInfo } = store.appStore;
        let params;
        if (window.location.search && getQueryVariable('filepath')) { // 文件打开前 从参数里面取（checkUserEnv的执行有可能比存 serviceModeOfClientInfo 早）
            params = window.location.search;
        } else if (serviceModeOfClientInfo && serviceModeOfClientInfo.filePath) { // 当文件打开后 参数会被 隐藏，从serviceModeOfClientInfo 取
            params = serviceModeOfClientInfo.serviceModeOfClientParams;
        }
        // TODO 目前只处理了 有 filePath 的场景（旧版本exe或者mac系统未处理）
        return `${params ? (_domain +  params) : _domain}`;
    }
    getTeamsRedirectUrl(domain, userEnv) {
        return `${domain || getOnlineUrl(userEnv)}?${window.location.search}`;
    }
    getOnlineCommonRedirectUrl(userEnv) {
        let targetEnvUrl;
        let userEnvOnlineUrl;
        const { isFromServiceModeOfClient } = store.appStore;
        const { inTeamsApp } = store.teamsAppStore;

        if (userEnv === 'eu') {
            targetEnvUrl = store.appStore.onlineEUUrl
        } else if (userEnv === 'ca') {
            targetEnvUrl = store.appStore.onlineCAUrl
        }

        // Teams
        if (inTeamsApp) return this.getTeamsRedirectUrl(targetEnvUrl, userEnv);

        // GoogleDrive Params
        const fileParams = getQueryVariable('state');
        const googleDriveAccessToken = storageGetItem(localStorage, 'GoogleDriveAccessToken')

        // SharePoint Params
        const oneDriveState = getQueryVariable('oneDriveState')
        const accessTokenId = getQueryVariable('SharePointTokenId')
        const refreshTokenId = getQueryVariable('refreshTokenId')


        if (fileParams) {
            if (googleDriveAccessToken) {
                userEnvOnlineUrl = `${targetEnvUrl}/?GoogleDriveAccessToken=${googleDriveAccessToken}&state=${fileParams}`
            } else {
                userEnvOnlineUrl = `${targetEnvUrl}/?state=${fileParams}`
            }
        } else if(oneDriveState && accessTokenId && refreshTokenId) {
            userEnvOnlineUrl = `${targetEnvUrl}/?oneDriveState=${oneDriveState}&SharePointTokenId=${accessTokenId}&refreshTokenId=${refreshTokenId}`
        } else if (isFromServiceModeOfClient) {
            userEnvOnlineUrl = this.getServiceModeOfClientRedirectUrl(targetEnvUrl, userEnv);
        } else {
            userEnvOnlineUrl = targetEnvUrl
        }

        userEnvOnlineUrl = userEnvOnlineUrl ? userEnvOnlineUrl : getOnlineUrl(userEnv);

        return userEnvOnlineUrl
    }
    getOnlineCAUrl(userEnv) {
        return this.getOnlineCommonRedirectUrl(userEnv)
    }
    getOnlineEUUrl(userEnv) {
        return this.getOnlineCommonRedirectUrl(userEnv)
    }
    goToTargetInstance(url, keepCurrentToken) {
        // 需要清除本地登录状态缓存
        this.clean(!keepCurrentToken, true)
        loginApis.cleanStorage(true);
        windowActionFn(window, 'open', ['about:blank', '_self']);
        windowActionFn(window, 'open', [url, '_self'])
    }
    checkUserEnv(token) {//ONLINERD-6688
        if (!this.userInfo || !store.appStore.environmentName) {
            return
        }

        let userEnv = this.userInfo.region;
        let { usApi, onlineUSUrl, onlineEUUrl, onlineCAUrl, isFromServiceModeOfClient } = store.appStore;
        if(isSharedClound()){
            return
        }

        // 非美国区、欧洲区、加拿大区不用处理
        if((!isPdfOnlineDomain() && !isCommonFeatureDomain())) {//us or eu or ca env
            return;
        }
        if(!userEnv) {
            if(isPdfOnlineDomain()) {
                return;
            }
            userEnv = 'us';
        }

        // 用户账号区域和当前online区域相同
        if(userEnv == store.appStore.environmentName) {
            if(isCommonFeatureDomain()){
                loginApis.getUserExistBusinessData({ token: token, baseUrl: usApi }).then((result) => {
                    const { data } = result;

                    if(data.result === true){
                        this.hasHistoricalData = true;
                    }
                })
            }
            return;
        }

        const { inTeamsApp } = store.teamsAppStore;

        // 美国账号登录欧洲或者加拿大区
        if(userEnv === 'us' && isCommonFeatureDomain()) {//EU Env 直接跳转 US Env
            onlineUSUrl = onlineUSUrl ? onlineUSUrl : getOnlineUrl(userEnv)
            if(!onlineUSUrl) {
                return;
            }
            if (inTeamsApp) {
                onlineUSUrl = this.getTeamsRedirectUrl(onlineUSUrl, userEnv);
            } else if (isFromServiceModeOfClient) {
                onlineUSUrl = this.getServiceModeOfClientRedirectUrl(onlineUSUrl, userEnv);;
            }
            this.clean(false);
            loginApis.cleanStorage(true);
            window.location.href = onlineUSUrl;

            return;
        }

        // 非teams环境的欧洲、加拿大账号登录美国区
        if ((userEnv === 'eu' || userEnv === 'ca') && isPdfOnlineDomain() && !inTeamsApp) {
            const isInEuUserList = userService.reduceDisturbForCommonDomainUser(this.userInfo)

            if (isInEuUserList) {
                return
            }
        }

        // 欧洲账号登录加拿大区
        if (userEnv === 'eu' && isCADomain()) {
            onlineEUUrl = onlineEUUrl ? onlineEUUrl : getOnlineUrl(userEnv)

            if (!onlineEUUrl) {
                return
            }
            if (inTeamsApp) {
                onlineEUUrl = this.getTeamsRedirectUrl(onlineEUUrl, userEnv);
            } else if (isFromServiceModeOfClient) {
                onlineEUUrl = this.getServiceModeOfClientRedirectUrl(onlineEUUrl, userEnv);;
            }

            this.clean(false);
            loginApis.cleanStorage(true);
            windowActionFn(window, 'open', [onlineEUUrl, '_self'])

            return;
        }

        // 加拿大账号登录欧洲区
        if ((userEnv === 'ca') && isEUDomain()) {
            onlineCAUrl = onlineCAUrl ? onlineCAUrl : getOnlineUrl(userEnv)

            if (!onlineCAUrl) {
                return
            }
            if (inTeamsApp) {
                onlineCAUrl = this.getTeamsRedirectUrl(onlineCAUrl, userEnv);
            } else if (isFromServiceModeOfClient) {
                onlineCAUrl = this.getServiceModeOfClientRedirectUrl(onlineCAUrl, userEnv);;
            }

            this.clean(false);
            loginApis.cleanStorage(true);
            windowActionFn(window, 'open', [onlineCAUrl, '_self'])

            return;
        }

        loginApis.getUserExistBusinessData({ token: token, baseUrl: usApi }).then(({ data }) => {
            let userEnvOnlineUrl
            let cancelText
            let messageText
            let onlineUrl = prop(location, 'protocol') + "//" + prop(location, 'host'); //current url
            const userEnv = this.userInfo.region;

            if (userEnv === 'eu') {
                userEnvOnlineUrl = this.getOnlineEUUrl(userEnv)
                cancelText = 'userEnv.goInstanceEu'
                messageText = 'userEnv.messageEu'
            }
            if (userEnv === 'ca') {
                userEnvOnlineUrl = this.getOnlineCAUrl(userEnv)
                cancelText = 'userEnv.goInstanceCa'
                messageText ='userEnv.messageCa'
            }

            if(!userEnvOnlineUrl) {
                return;
            }
            let downloadUrl = onlineUrl + '/download-share';

            if(data.result === true) {
                if (inTeamsApp) { // teams中直接跳转，不需要弹窗提示
                    this.goToTargetInstance(userEnvOnlineUrl);
                    return ;
                }
                store.appStore.onShowWarningMessage((res)=>{
                    if(res === false) { //cancel Go to EU Instance
                        this.goToTargetInstance(userEnvOnlineUrl, true);
                    } else { //ok Go to Download Webpage
                        window.location.href = downloadUrl;
                    }
                }, {
                        message: messageText,
                        messageParams: {url: downloadUrl},
                        iconType: 'prompt',
                        title: 'userEnv.title',
                        ok: 'userEnv.goWebpage',
                        cancel: cancelText,
                        noCancel: false
                }, true);
            } else if(data.result === false) {
                this.goToTargetInstance(userEnvOnlineUrl, true)

                return;
            }
        });
    }
    @action showAiLitterHelper(){
        let isHide = true;
        if (! isMobile()) {
            // !pathname && (pathname = prop(location, 'pathname'))
            // let useAiPlugin = baseUrlApis.getQueryVariable('ai_plugin')
            // if( useAiPlugin){
                isHide = false;
            // }
        }
        store.appStore.showLittleHelper(isHide)
    }
    @action doGoToHomePage(){
        browserService.doGoToHomePage()
        this.showAiLitterHelper('/');
    }
    @action async doSignUpAndSignIn({email, password, name, phone, firstName, lastName, codeID, requestCode, success, error}) {
        password = await encryptAES(password, this.getEncryptKey(), '');
        if(phone) {
            phone = await encryptAES(phone, this.getEncryptKey(), '');
        }
        loginApis.doSignUpAndSignIn({
            email,
            password,
            name,
            phone,
            firstName,
            lastName,
            codeID,
            requestCode,
            callback: (result) => {
                const { ret, data = {} } = result;

                // otelApi.sendJaegerData({
                //     spanName: 'sign_up_success',
                //     operationName: 'sign_up_success',
                //     extraInformation: {
                //         _group3: 'activities'
                //     },
                //     moreInfo: {
                //         userID: data.user_id
                //     }
                // })

                success && success()

                if(ret !== 0){
                    userBehaviorTrackingService.doSendGAEventByUserEvent(SIGN_UP_FAILED_FROM_FOXIT, '');
                    let id = 'SignUp.PlatformError';
                    switch(ret) {
                        case 100005:
                            id = 'SignUp.EmailExist';
                            break;
                        case 2100080:
                            id = 'SignUp.RequestsLimit';
                            break;
                    }

                    let errMessage = intl.formatMessage({id});
                    //
                    if(ret !== 100005){
                        store.appStore.doPostError({
                            level:'warn',
                            category:'sign up',
                            data:{message: errMessage, reason: result}
                        })
                    }
                    store.appStore.setGlobalMessage({type: 'error', content: errMessage});
                    return;
                }
                // need to wait activate email
                this.OnCancelSignUpDlg();
                store.appStore.setGlobalModalConfig({
                    visible: true,
                    title: intl.get('SignUp.SignUpSuccess'),
                    children: intl.get('SignUp.SignUpSuccessContent'),
                    cancelButtonProps: {style: {display: 'none'}},
                });
                if (data.user_id) {
                    let signUpSuccessUsers = JSON.parse(storageGetItem(localStorage, 'SignUpSuccessUsers') || '[]');
                    storageSetItem(localStorage, 'SignUpSuccessUsers', JSON.stringify([...signUpSuccessUsers, data.user_id]));
                }
            },
            error:(err)=>{
                let errMessage = intl.formatMessage({id: 'SignUp.PlatformError'})
                store.appStore.doPostError({
                    level:'warn',
                    category:'sign up',
                    data:{message: errMessage, reason: !!err?err:''}
                })
                store.appStore.setGlobalMessage({type: 'error', content: errMessage});

                error && error(err)
            }
        });
    }
    @action loginIn(useCurrentWindow, params){
        let isFromUserHandleLogin = false;
        let isFromTokenExpired = false;

        sharePointGASender.signInPopUp()

        if(params){
            isFromUserHandleLogin = params.isFromUserHandleLogin;
            isFromTokenExpired = params.isFromTokenExpired;
            let param = params.autoThird? params.autoThird:'';
            this.doSendGAEventByUser({eventKey:'sign_in', label:'sign_up', param})
        }else{
            this.doSendGAEventByUser({eventKey:'sign_in', label: 'upper_right_area'})
        }
        this.clean(true);
        const onLoginByMessage = async ({ticket, enterpriseId, remember_me, role, fromTeamsToken})=>{
            let result = await userService.getUserInfoByTicket(ticket, enterpriseId, remember_me, role, fromTeamsToken);
            if( result.ret !== 0 || result.token ){
                if(result.token) {
                    //ONLINERD-6688 登录成功->
                    this.checkUserEnv(result.token);
                }
            }
            store.appStore.showWaitingForSignIn(false);

            await store.collaborationStore.startNotificationPolling();

            sharePointGASender.signInSuccessful()
            if (this.hasSignIn && this.userInfo && this.userInfo.cUserID) {
              const signUpSuccessUsers = JSON.parse(storageGetItem(localStorage, 'SignUpSuccessUsers') || '[]');
              if (signUpSuccessUsers.indexOf(this.userInfo.cUserID) !== -1) {
                // ga
                userBehaviorTrackingService.doSendGAEventByUserEvent(SIGN_UP_SUCCESS_FROM_FOXIT, '');
                signUpSuccessUsers.splice(signUpSuccessUsers.indexOf(this.userInfo.cUserID), 1);
                storageSetItem(localStorage, 'SignUpSuccessUsers', JSON.stringify(signUpSuccessUsers));
              }
            }
            if (isFromUserHandleLogin && enterpriseId) {
                this.updateRoleInfo(role, enterpriseId, true);
            }
            if (isFromTokenExpired) {
                store.userStore.doSendGAEventByUser({eventKey: TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_SIGNIN_SUCCESSFUL, label: TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_LABEL})
            }
            this.isTokenExpired = false;
            store.foxitSignStore.initFoxitSignCountInfo();
            store.appStore.initEnterpriseSettingInfo();
        }
        const onCloseWindow = ()=>{
            if (isFromTokenExpired) {
                store.userStore.doSendGAEventByUser({eventKey: TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_SIGNIN_INTERRUPTED, label: TOKEN_EXPIRED_LOGIN_POP_UP_WINDOW_LABEL})
            }
            store.appStore.showWaitingForSignIn(false);
        }
        useCurrentWindow = useWindow(useCurrentWindow);
        if(!useCurrentWindow && store.appStore.loginInNewWindow){
            store.appStore.showWaitingForSignIn(true);
        }
        loginApis.loginFn( !useCurrentWindow, onLoginByMessage, onCloseWindow, params);
    }

    @action OnCancelSignUpDlg() {

        this.isShowSignUpDlg = false
    }
    @action signUp(noSendGA, useCurrentWindow){
        if(store.appStore.isOnPremiseDeployMode)return;
        if(!noSendGA) this.doSendGAEventByUser({eventKey:'sign_up', label: 'upper_right_area'})

        sharePointGASender.signUpPopUp()

        this.clean(true);
        const onLoginByMessage = async ({ticket, enterpriseId, remember_me, role, fromTeamsToken})=>{
            let result = await userService.getUserInfoByTicket(ticket, enterpriseId, remember_me, role, fromTeamsToken);
            if( result.ret !== 0 || result.token ){
                if(result.token) {
                    //ONLINERD-6688 登录成功->
                    this.checkUserEnv(result.token);
                }
            }
            store.appStore.showWaitingForSignIn(false);

            await store.collaborationStore.startNotificationPolling();

            sharePointGASender.signUpSuccessful()

            if (this.hasSignIn && this.userInfo && this.userInfo.cUserID) {
                const signUpSuccessUsers = JSON.parse(storageGetItem(localStorage, 'SignUpSuccessUsers') || '[]');
                if (signUpSuccessUsers.indexOf(this.userInfo.cUserID) !== -1) {
                    // ga
                    userBehaviorTrackingService.doSendGAEventByUserEvent(SIGN_UP_SUCCESS_FROM_FOXIT, '');
                    signUpSuccessUsers.splice(signUpSuccessUsers.indexOf(this.userInfo.cUserID), 1);
                    storageSetItem(localStorage, 'SignUpSuccessUsers', JSON.stringify(signUpSuccessUsers));
                }
            }
        }
        const onCloseWindow = ()=>{
            store.appStore.showWaitingForSignIn(false);
        }
        useCurrentWindow = useWindow(useCurrentWindow);
        if(!useCurrentWindow){
            store.appStore.showWaitingForSignIn(true, 'sign-up');
        }
        loginApis.signUpFn( !useCurrentWindow, onLoginByMessage, onCloseWindow);
    }
    @action loginOut(noSendGA, reLogin, isFromInitializeOnFirst = false){
        const fun = () => {
            if (store.appStore.isCollaborationMode()){
                if (!noSendGA) store.userStore.doSendGAEvent({eventKey: EXIT, label:'review_mode_upper_right_area'});
            }else{
                if (!noSendGA) this.doSendGAEventByUser({ eventKey: EXIT, label: 'upper_right_area' });
            }
            const MESSAGE_KEY = 'online.user.status';
            try {
                userService.updateHideNotifyErrors(true)
                loginApis.deleteToken().then(()=>{
                    // default
                    if(!store.teamsAppStore.inTeamsApp){
                        loginApis.doPostMessageToParentWindow(MESSAGE_KEY, 'user.login.out');
                        this.clean(true);
                        // userService.cleanLoggedInRegionCookie()
                        store.collaborationStore.stopNotificationPolling()
                        // Use editor by Teams website.
                        if (window.parent !== window || isTeamsApp) {
                            store.collaborationStore.clean();
                        }
                        let useCurrentWindow = useWindow(true);
                        let url = signOutIfTeamsWebsiteUrl();
                        return loginApis.loginOutFn(url, reLogin, !useCurrentWindow);
                    }

                    store.collaborationStore.clean();

                    signOutFoxitWithinTeams().then(() => {
                        store.teamsAppStore.updateHasSignInFoxitForTeamsApp(false)
                        store.collaborationStore.exitCollaborationForTeamsApp(true)
                    }).catch(e => {
                        console.log("signout fot teams app error", e);
                    }).finally(()=>{
                        loginApis.doPostMessageToParentWindow(MESSAGE_KEY, 'user.login.out');
                        this.clean(true);
                        store.collaborationStore.stopNotificationPolling()
                        loginApis.loginOutFn('', reLogin);
                        store.appStore.doUpdateSignInNotice({id:'Permission.SignIn'});
                    })

                }).finally(() => {
                    userService.resetHideNotifyErrors()
                })
            } catch (error) {
                console.error("===>>> ~ UserStore ~ @action loginOut ~ error", error);
            }
        }
        if (window.onShowToSaveBeforeOpen) {
            window.onShowToSaveBeforeOpen((isToSave) => {
                if (!isToSave) {
                    fun();
                }
            }, isFromInitializeOnFirst);
        } else {
            fun();
        }
    }

    @action reLogin(useNewWindow){
        this.doSendGAEventByUser({eventKey:'sign_in', label: 'upper_right_area'})
        this.clean(true);
        const onLoginByMessage = async ({ticket, enterpriseId, remember_me, role})=>{
            let result = await userService.getUserInfoByTicket(ticket, enterpriseId, remember_me, role);
            if( result.ret !== 0 || result.token ){
                // TODO: show login info
                if(result.token) {
                    //ONLINERD-6688 登录成功->
                    this.checkUserEnv(result.token);
                }
            }
            if (this.userInfo.cUserID) {
                const signUpSuccessUsers = JSON.parse(storageGetItem(localStorage, 'SignUpSuccessUsers') || '[]');
                if (signUpSuccessUsers.indexOf(this.userInfo.cUserID) !== -1) {
                    // ga
                    userBehaviorTrackingService.doSendGAEventByUserEvent(SIGN_UP_SUCCESS_FROM_FOXIT, '');
                    signUpSuccessUsers.splice(signUpSuccessUsers.indexOf(this.userInfo.cUserID), 1);
                    storageSetItem(localStorage, 'SignUpSuccessUsers', JSON.stringify(signUpSuccessUsers));
                }
            }
        }
        const onCloseWindow = ()=>{
            store.appStore.showWaitingForSignIn(false);
        }
        if(useNewWindow && store.appStore.loginInNewWindow){
            store.appStore.showWaitingForSignIn(true);
        }
        //callback, onCloseWindow
        loginApis.loginOutFn('', true, useNewWindow,{ callback: onLoginByMessage, onCloseWindow });
    }

    @action getSurveyNPS(){
        return userService.getSurveyNPS();
    }
    @action updateSurveyNPS(params){
      return userService.updateSurveyNPS(params);
    }
    @action getEncryptKey(){
        return encryptKey;
    }
    @computed get clientRequestMd5Key() {
        return 'H4m&!T';
    }
    @action getTermsChangeNotify(){
        if(!this.userInfo)return '';
        return this.userInfo.termsChangeNotify
    }
    @action doUpdateUserNotify({userNotifyType, userNotifyStatus}, callback) {
        userService.updateUserNotify({ userNotifyType, userNotifyStatus }, callback)
    }
    @action setIntervalCheckToken(token){
        return
        this.tokenTimer = setInterval(async()=>{
            const { ret/* , info */ } = await userService.getUserInfo(token);
            const { docModified } = store.appStore;
            const { fileName } = store.docStore.docInfo;
            if(ret === 210007){
                store.appStore.onShowWarningMessage((isOk) => {
                        if(isOk && docModified){
                            fileController.saveToLocal(() => {
                                store.appStore.doUpdateDocModified(false);
                                pdfui.createNewDoc();
                            });
                        }
                        this.loginOut(true, true);
                  }, {
                    message: docModified?'SignUp.credentialsExpiredModify':'SignUp.credentialsExpired',
                    messageParams: {name: fileName},
                  }, true);
                  this.cleanTokenTimer()
            }
        },600000)
    }
    @action cleanTokenTimer(){
        clearInterval(this.tokenTimer)
    }
    @action getRequestCode({codeID}, successCallback, errorCallback){
        userService.getRequestCode({codeID}, successCallback, errorCallback)
    }
    @action guideToolTip(name,toolTipMsg){//esignCN  弹窗引导
        let local = storageGetItem(localStorage, name)
        if(local)return
        this.showTooltip(toolTipMsg)
        storageSetItem(localStorage, name,true);
    }
    @action  showTooltip({targetDom, id,title, content, width, height,translateX,translateY}) {
        if (document.getElementById(id) == null && targetDom) {
            if(!translateX){translateX=0}
            if(!translateY){translateY=0}
            const isIE = navigator.userAgent.indexOf('MSIE') > -1;
            let tooltipBox;
            tooltipBox = document.createElement('div');
            tooltipBox.classList.add('toolTip_box', 'toolTip_box_right');
            tooltipBox.id = id;
            let closeBtn = document.createElement('div');
            closeBtn.innerHTML = 'X';
            tooltipBox.appendChild(closeBtn);
            closeBtn.style.position='absolute'
            closeBtn.style.right='10px'
            closeBtn.style.top='5px'
            closeBtn.style.cursor='pointer';

            if(title){
                let h1 = document.createElement('h1');
                h1.innerHTML = title;
                tooltipBox.appendChild(h1);
            }
            if(content){
                let p1 = document.createElement('p');
                p1.innerHTML = content;
                tooltipBox.appendChild(p1);
            }

            document.body.appendChild(tooltipBox);

            tooltipBox.style.width = width ? width + 'px' : 'auto';
            tooltipBox.style.height = height ? height + 'px' : 'auto';

            if (!width && isIE) {
                tooltipBox.style.width = tooltipBox.offsetWidth;
            }

            tooltipBox.style.position = "fixed";
            tooltipBox.style.display = "block";
            let rectInfo = targetDom.getBoundingClientRect();
            let left = rectInfo.left-tooltipBox.offsetWidth/2+rectInfo.width/2+translateX;
            let top = rectInfo.top+rectInfo.height+10+translateY;

            left -= 70;
            if (left + tooltipBox.offsetWidth > document.body.clientWidth) {
                if (left < 0) left = 0;
            }

            tooltipBox.style.left = left + 'px';
            tooltipBox.style.top = top + 'px';
            closeBtn.addEventListener('click',()=>{
                tooltipBox.remove()
            })
            // targetDom.onmouseleave = function () {
                setTimeout(function () {
                    tooltipBox.remove()
                }, 3000);
            // };

        }
    }
    @action async showFoxitEsignTooltip() {
        if (store.foxitSignStore.isDisableEsign) {
            return;
        }
        let FoxitEsignTabTooltipShowMapKey = 'FoxitEsignTabTooltipShowMap'
        let { cUserID } = this.userInfo;
        let isFoxitEsignTabTooltipDisplayed = getLocalStorageUserMapValue(cUserID, localStorage, FoxitEsignTabTooltipShowMapKey);
        if (isFoxitEsignTabTooltipDisplayed) return;
        let wrapFoxitESign = await store.viewer.pdfui.getComponentByName('wrap-foxitESign-tab');
        if (!wrapFoxitESign) return;

        wrapFoxitESign.controller.show();
        setLocalStorageUserMapValue(cUserID, localStorage, FoxitEsignTabTooltipShowMapKey, true);
    }

    @action setAccountWithAutoRefreshStore(account, code, callback, isMobile = true) {
        return userService.setAccount(account, code,  isMobile, async res => {
            if (res === true) {
                const { info } = await userService.getUserInfo(store.userStore.token);
                this.userInfo = info;
            }
            callback && callback()
        });

    }

    @action async checkAccountExist(account, callback, isMobile = true) {
        account = account && await encryptAES(account, this.getEncryptKey(), '', true);
        return userService.checkAccountExist(account, isMobile, callback)
    }

    @action async sendVerificationCode(account, callback, isMobile = true) {
        account = account && await encryptAES(account, this.getEncryptKey(), '', true);
        return userService.sendVerificationCode(account, isMobile, callback)
    }

}
export default UserStore;
